/* eslint-disable camelcase */
import * as z from 'zod'

const emailSchema = z.union([
  z
    .string()
    .min(1, { message: 'Please enter a contact email' })
    .email('Must be a valid email'),
])

export const schema = z
  .object({
    vehicleType: z
      .string({ required_error: 'This field is required' })
      .min(1, { message: 'Please enter a vehicle type' }),
    pickupAddress: z
      .string({ required_error: 'This field is required' })
      .min(1, { message: 'Please enter a pickup address' }),
    contactName: z
      .string({ required_error: 'This field is required' })
      .min(1, { message: 'Please enter a contact name' }),
    contactEmailAddress: emailSchema,
    contactMobileNumber: z
      .string()
      .min(1, { message: 'Please enter a contact mobile number' })
      .refine((value) => /^\d{9,11}$/.test(value), {
        message: 'Invalid mobile number',
      }),
    reservationReason: z.string().optional(),
    Reason: z.string().optional(),
    comments: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    // ✅ Apply reservation rules only for Relief
    if (data.requestType === 'Relief') {
      if (!data.reservationReason) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['reservationReason'],
          message: 'Please enter a reservation reason',
        })
      }

      if (data.reservationReason === 'Service') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['reservationReason'],
          message: 'A relief vehicle cannot be booked for \'Service\'',
        })
      }

      if (data.reservationReason === 'Other' && !data.Reason) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['Reason'],
          message: 'Reason is required when \'Other\' selected',
        })
      }
    }
  })
